export default "/images/daa58744c0ea241e0557b7597facdcf5.png";